<template src="./Login.html"></template>
<style src="./Login.scss" lang="scss"></style>

<script>
  import Bento from '@/components/Bento/Bento'
  import Button from '@/components/Button/Button'
  import Input from '@/components/Input/Input'
  import Icon from '@/components/Icon/Icon'
  import { Helper } from '@/services/helper/helper'
  import { AdServiceWrapper } from '@/services/wrapper/adServiceWrapper'

  /**
   * The Login component on the page.
   * @vue-data {Object[]} logins An array of configuration objects for possible logins
   * @vue-data {Object} currentLogin The configuration object of the current selected login
   * @vue-data {'accent' | 'primary'} buttonImportance The color of the button mapped by importance
   * @vue-data {string} ngUserId The NGUserID to be put in login as hidden field after it was received
   * @vue-data {string} ibaInfo Some information about adblocker, os, browser and device class for target page
   * @vue-data {string} tpidHash tpid hash required for netId hidden params
   * @vue-data {string} salt salt required for netId hidden params
   * @vue-data {Object} emailInput Information about the email input field in login
   * @vue-data {Object} emailLink Information about the email link in login
   * @vue-data {Object} passwordInput Information about the password input field in login
   * @vue-data {Object} passwordLink Information about the password link in login
   * @vue-data {string} brandName Current brand of page
   * @listens Document#abdDone
   */
  export default {
    name: 'HpLogin',
    data () {
      return {
        logins: this.$store.state.contentData.logins,
        currentLogin: this.$store.state.contentData.logins[0],
        buttonImportance: 'accent',
        ngUserId: '',
        ibaInfo: '',
        tpidHash: '',
        salt: '',
        emailInput: {
          htmlId: 'loginfield',
          inputType: 'email',
          placeholder: this.$store.state.contentData.logins[0]?.credentials?.[0]?.input?.placeholder || '',
          inputvalue: '',
          required: true,
          name: this.$store.state.contentData.logins[0]?.credentials?.[0]?.input?.name || 'credentials[]'
        },
        emailLink: this.$store.state.contentData.logins[0]?.credentials?.[0].link || {},
        passwordInput: {
          htmlId: 'passwordfield',
          inputType: 'password',
          placeholder: this.$store.state.contentData.logins[0]?.credentials?.[1]?.input?.placeholder || '',
          inputvalue: '',
          required: true,
          name: this.$store.state.contentData.logins[0]?.credentials?.[1]?.input?.name || 'credentials[]'
        },
        passwordLink: this.$store.state.contentData.logins[0]?.credentials?.[1].link || {},
        brandName: ''
      }
    },
    computed: {
      bentoData () {
        return {
          elements: this.logins.map((login, index) => {
            return {
              loginId: index,
              link: login.link,
              text: login.text,
              icon: {
                type: login.icon
              }
            }
          }),
          footer: this.$store.state.contentData.bentoFooter
        }
      }
    },
    watch: {
      currentLogin () {
        this.emailInput.name = this.currentLogin.credentials?.[0]?.input?.name || 'credentials[]'
        this.emailInput.placeholder = this.currentLogin.credentials?.[0]?.input?.placeholder || ''
        this.emailLink = this.currentLogin.credentials?.[0]?.link || {}
        this.passwordInput.name = this.currentLogin.credentials?.[1]?.input?.name || 'credentials[]'
        this.passwordInput.placeholder = this.currentLogin.credentials?.[1]?.input?.placeholder || ''
        this.passwordLink = this.currentLogin.credentials?.[1]?.link || {}
      }
    },
    methods: {
      /**
       * Actions to perform on login submit.
       * @param {Event} event The click event of login button
       */
      submit (event) {
        let form = this.$el.querySelector('form') || ''
        if (!form) {
          console.log('FORM not found')
          return
        }
        let formValidity = true
        for (let input of form.elements) {
          if (!input.checkValidity()) {
            input.setAttribute('aria-invalid', '')
            formValidity = false
          }
        }
        !formValidity && event.preventDefault()
      },
      getNetIDHiddenValues () {
        const qa = Helper.isLiveStage() ? '' : '.qa'
        let url = `https://ap-info${qa}.netid.de/accountproviderinfo?apid=`

        switch (this.brandName) {
          case 'webde':
            url += 'e5ccedf9-7ba6-473f-b04b-21a0ac2a608a'
            break
          case 'gmx':
            url += '42f2dbe6-174e-42ab-842f-4eb48544400b'
            break
          default:
            // 1und1 is missing
            return
        }

        Helper.xhr(url).then((request) => {
          try {
            const data = JSON.parse(request.response)
            this.tpidHash = data.tpid_hash
            this.salt = data.salt
          } catch (e) {}
        })
      },
      /**
       * Handles the change event from the bento
       * this event currently changes the login type
       * @param {Object} login a login element from bentoData.elements
       */
      onBentoChange (login) {
        if (login.link) {
          return
        }
        this.currentLogin = this.logins[login.loginId]
      }
    },
    beforeCreate () {
      document.addEventListener('abdDone', (event) => {
        this.ibaInfo = 'os=' + window.AdService.getParam('os') + ';browser=' + window.AdService.getParam('browser') + ';deviceclass=' + window.AdService.getParam('deviceclass') + ';abd=' + event.detail.abd
      })
    },
    mounted () {
      this.brandName = process.env.VUE_APP_BRAND

      if (this.brandName === 'webde') {
        this.buttonImportance = 'primary'
      }

      this.getNetIDHiddenValues()

      AdServiceWrapper.getNgUserIdCookie((ngUserId) => {
        console.log('NGUserID', ngUserId)
        this.ngUserId = ngUserId
      })
    },
    components: {
      'hp-bento': Bento,
      'hp-button': Button,
      'hp-input': Input,
      'hp-icon': Icon
    }
  }
</script>
